module.exports = __webpack_public_path__ + "img/question.ea827bcb.svg";